import {Injectable} from '@angular/core';
import {JwtHelperService} from '@auth0/angular-jwt';
import {BehaviorSubject, Observable} from 'rxjs';

// import { CookieService } from 'ngx-cookie-service';

// export interface Credentials {
//   // Customize received credentials here
//   username: string;
//   token: string;
// }

export interface CredentialsState {
  isUserAuthenticated: boolean;
  signedInUser: SignedInUser | null;
}


export interface Credentials {
  username?: string;
  accessToken: string;
  refresh_token: string;
  userId?: string;
  // selected_vertical?: string;
  // userProfileImage: string;
}

export interface TokenDetails {
  /** Can add other properties also as needed */
  expiresIn: number;
}

export interface SignedInUser {
  userId?: string;
  authorities?: string[];
  username?: string;
  firstName?: string;
  lastName?: string;
  profileImage?: string;
}


const credentialsKey = 'credentials';
// tslint:disable-next-line:variable-name
const selected_vertical = 'selected_vertical';
// tslint:disable-next-line:variable-name
const admin_user = 'adminUser';
const isEditVertical = 'isEditVertical';
const userDetails = 'userDetails'

/**
 * Provides storage for authentication credentials.
 * The Credentials interface should be replaced with proper implementation.
 */
@Injectable({
  providedIn: 'root',
})
export class CredentialsService {
  public currentCredentialsState: Observable<CredentialsState>;

  private credentialsState = new BehaviorSubject<CredentialsState>({
    isUserAuthenticated: false,
    signedInUser: null,
  });

  constructor(
    // private userMgmtService: UserMgmtService
  ) {
    this.currentCredentialsState = this.credentialsState.asObservable();

    const savedCredentials =
      sessionStorage.getItem(credentialsKey) ||
      localStorage.getItem(credentialsKey);
    if (savedCredentials) {
      // this._credentials = JSON.parse(savedCredentials);
      this.setCredentials(JSON.parse(savedCredentials));

      // this.credentialsState.next({
      //     isUserAuthenticated: true,
      //     signedInUser: this.signedInUser,
      // });
    } else {
      this.credentialsState.next({
        isUserAuthenticated: false,
        signedInUser: null,
      });
    }
  }

  // tslint:disable-next-line:variable-name
  private _credentials: Credentials | null = null;

  /**
   * Gets the user credentials.
   * @return The user credentials or null if the user is not authenticated.
   */
  get credentials(): Credentials | null {
    let theCredentials = localStorage.getItem(credentialsKey);
    if (!theCredentials) {
      theCredentials = sessionStorage.getItem(credentialsKey);
    }
    if (!theCredentials) {
      return null;
    }
    return this._credentials;
  }

  get tokenDetails(): TokenDetails | null {
    if (!this.credentials) {
      return null;
    }
    const jwtHelper = new JwtHelperService();
    const decodedToken = jwtHelper.decodeToken(this.credentials.accessToken);
    const tokenDetails = {
      expiresIn: decodedToken.exp,
    };
    return tokenDetails;
  }

  // tslint:disable-next-line:variable-name
  private _signedInUser: SignedInUser | null = null;

  get signedInUser(): SignedInUser | null {
    return this._signedInUser;
  }

  /**
   * Checks is the user is authenticated.
   * @return True if the user is authenticated.
   */
  isAuthenticated(): boolean {
    // return !!this.credentials;

    const helper = new JwtHelperService();
    if (this.credentials) {
      const accessToken = this.credentials.accessToken;
      const tokenExpired = helper.isTokenExpired(accessToken);
      if (tokenExpired) {
        this.setCredentials();
        console.log(
          '...Token has expired. Login Again [Can implement Refresh Token in future]'
        );
        return false;
      } else {

      }
    }
    return !!this.credentials;
  }

  /**
   * Sets the user credentials.
   * The credentials may be persisted across sessions by setting the `remember` parameter to true.
   * Otherwise, the credentials are only persisted for the current session.
   * @param credentials The user credentials.
   * @param remember True to remember credentials across sessions.
   */
  setCredentials(credentials?: Credentials, remember?: boolean) {


    this._credentials = credentials || null;

    if (credentials) {

      const storage = remember ? localStorage : sessionStorage;

      storage.setItem(credentialsKey, JSON.stringify(credentials));
      this.setSignedInUser(credentials);

      // this.cookieService.set(credentialsKey, JSON.stringify(credentials));
    } else {

      sessionStorage.removeItem(credentialsKey);
      localStorage.removeItem(credentialsKey);
      this.credentialsState.next({
        isUserAuthenticated: false,
        signedInUser: null,
      });
    }
  }

  // updateProfileImage(profileImage: string) {
  //
  //     this._credentials.userProfileImage = profileImage;
  //     this.setCredentials(this._credentials);
  //     // this.setSignedInUser(this._credentials);
  //
  // }

  public setSignedInUser(credentials: Credentials, detailedLoggedInUser?: any) {
    if (!credentials) {
      return;
    }
    const jwtHelper = new JwtHelperService();
    const decodedToken = jwtHelper.decodeToken(credentials.accessToken);


    const theSignedInUser: SignedInUser = {
      userId: detailedLoggedInUser?.userId,
      username: detailedLoggedInUser?.username,
      firstName: detailedLoggedInUser?.firstName,
      lastName: detailedLoggedInUser?.lastName,
      authorities: decodedToken?.authorities,
      // profileImage: credentials.userProfileImage,
    };

    this.credentialsState.next({
      isUserAuthenticated: true,
      signedInUser: theSignedInUser
    });
    this._signedInUser = theSignedInUser;


  }

}
